import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TEST_ID = 'softball-icon';
export const SoftballColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Softball" fill="none" fillRule="evenodd" data-testid={TEST_ID}>
                <path d="M0 0h24v24H0z" />
                <path
                    d="M19.071 19.071c-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142z"
                    fill="#D7FF38"
                />
                <path
                    d="M1.356 11.32A8.038 8.038 0 0 1 12.68 22.645l-1.53-1.29a6.038 6.038 0 0 0-8.505-8.506l-1.29-1.53zM14.435 2.496a9.209 9.209 0 0 0 2.5 4.57 9.209 9.209 0 0 0 4.57 2.5l-.425 1.953a11.209 11.209 0 0 1-5.56-3.04 11.209 11.209 0 0 1-3.04-5.559l1.955-.424z"
                    fill="#FF4054"
                    fillRule="nonzero"
                />
                <path
                    d="M4.222 4.222c-4.296 4.296-4.296 11.26 0 15.556 4.296 4.296 11.26 4.296 15.556 0 4.296-4.296 4.296-11.26 0-15.556-4.296-4.296-11.26-4.296-15.556 0zm14.142 1.414a9 9 0 1 1-.21-.203l.21.203z"
                    fill="#0A0B0D"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};
